export type NoCompanyVariant = "default" | "archived" | "impersonated" | "archivedImpersonated";

export const resolveNoCompanyVariant = (
    hasOnlyArchivedOrganizations: boolean,
    isImpersonating: boolean,
): NoCompanyVariant => {
    if (hasOnlyArchivedOrganizations) {
        return isImpersonating ? "archivedImpersonated" : "archived";
    }

    return isImpersonating ? "impersonated" : "default";
};
